export default __webpack_public_path__ + "static/media/skills-icon.4e3befaf.svg";